// @flow

import {Tooltip, makeStyles} from '@material-ui/core';
import React from 'react';

import PreOrderSvg from '../icons/PreOrderSvg';
import {colors} from '../../../../assets/styles/colors';
const useStyles = makeStyles(() => ({
  tooltipIcon: {
    width: 18,
    height: 18,
    marginRight: 8,
  },
  tooltip: {
    borderRadius: '6px',
    background: colors.grey300,
    color: colors.grey800,
  },
}));

const FromPreOrderTooltip = ({isPreOrder = false}: {isPreOrder?: boolean}) => {
  const classes = useStyles();

  return (
    <Tooltip
      placement="top"
      classes={{tooltip: classes.tooltip}}
      enterTouchDelay={0}
      title={
        isPreOrder ? (
          <div>
            Este pedido es un <br /> Pre Pedido
          </div>
        ) : (
          <div>
            Este pedido fue un <br /> Pre Pedido
          </div>
        )
      }
    >
      <PreOrderSvg className={classes.tooltipIcon} />
    </Tooltip>
  );
};

export default FromPreOrderTooltip;
